"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _QuestionEntityRecord = _interopRequireDefault(require("./QuestionEntityRecord"));

var _replaceNewLinesWithBreaks = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/utils/replaceNewLinesWithBreaks"));

var QuestionAndAnswerNote = function QuestionAndAnswerNote(_ref) {
  var question = _ref.question,
      properties = _ref.properties;
  var optionsItem;
  var noteItem;

  if ((!question.note || question.note === '') && question.selected.isEmpty()) {
    return null;
  }

  if (question.objectType && question.propertyName) {
    var property = properties.getIn([question.objectType, 'properties', question.propertyName]);
    question = question.setProperty(property);
  }

  if (question.getDisplayValue()) {
    optionsItem = _react.default.createElement("li", null, (0, _replaceNewLinesWithBreaks.default)(question.getDisplayValue()));
  }

  if (question.note && question.note !== '') {
    noteItem = _react.default.createElement("li", null, (0, _unescapedText.default)('composer-plugins.questionAndAnswer.notesWithLabel', {
      notes: question.note
    }));
  }
  /*
  Note: This Component is used to general the note on a contact/deal/ticket/company records
  It should return only elements from the HTML spec and pure functional components called
  as functions (e.g. instead of `<MyComponent prop={myProp} />` use `MyComponent({ prop: myProp })`) */


  return _react.default.createElement("div", null, _react.default.createElement("b", null, question.question), _react.default.createElement("ul", null, optionsItem, noteItem));
};

QuestionAndAnswerNote.propTypes = {
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired,
  properties: _react.PropTypes.instanceOf(_immutable.Map).isRequired
};
var _default = QuestionAndAnswerNote;
exports.default = _default;
module.exports = exports.default;